// extracted by mini-css-extract-plugin
module.exports = {"avatar":"ForecastDetail_avatar__oMXVX","avatarImage":"ForecastDetail_avatarImage__4fvnn","avatar_right":"ForecastDetail_avatar_right__3Zlow","grade":"ForecastDetail_grade__2vGgT"};